import { cache } from '@appbase/util'
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex';
import * as accountTypes from '@account/store/types';
import { splash } from '@/modules/@appbase/util/splash-message';
import api from '@orgmap/api'

@Component({
    name: 'DetailCard',
    computed: {
        ...mapGetters({
          user: accountTypes.USER,
        }),
      },
})
export default class DetailCard extends Vue {
    @Prop({ type: Object }) item!: orgmap.TMemberItem | null
    @Prop({ type: String }) companyName!: string
    @Prop({ type: String }) userlang!: string

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    user!: account.User

    isCallable: boolean = false;

    visible: boolean = false
    avatar = {
        url: '',
        loading: false,
    }

    companyNameDisplay: string = ''

    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: W A T C H : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Watch('item')
    onItemChanged(newVal: orgmap.TMemberItem | null) {
        this.companyNameDisplay = this.companyName
        this.updateVisible(newVal)
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    mounted() {
        this.updateVisible(this.item)
        this.setCallableFlag();
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    getFax(item: orgmap.TMemberItem) {
        if (item.officeFax) {
            return `(FAX : ${item.officeFax})`;
        }
        return '';
    }

    handleClose() {
        this.visible = false
    }

    updateVisible(item: orgmap.TMemberItem | null) {
        this.visible = item ? true : false
        cache.avatar.get(item?.email || '').then((url) => {
            this.avatar.url = url
            this.avatar.loading = false
        })
    }

    setCallableFlag(){
        //CJ IPT 기능 사용하는 회사코드 목록
        const callableCompanies = ['COM22'];
        if(
            callableCompanies.indexOf(this.user.comCode.toString().toUpperCase())!=-1
            // callableCompanies.indexOf(testCompany.toUpperCase())!=-1
        ){
            this.isCallable = true;
        }
    }

    catchImgError() {
        if (
            (this.$refs.photo as HTMLImageElement) != undefined &&
            (this.$refs.photo as HTMLImageElement).src !== window.location.href
        ) {
            ; (this.$refs.photo as HTMLImageElement).src = '/cm/gres/faux/images/ghost.png'
        }
    }

    openTeamsChat() {
        if(this.item) {
            var segment = this.item.id.indexOf('_');
            var account = this.item.id.substring(segment + 1);

            var chatUrl = `MSTeams:/l/chat/0/0?users=${account}@kyoboaxa.com`

            if (this.isTeams) {
                window.location.href = chatUrl;
            } else {
                var childWindow = window.open(chatUrl);
                
                // if(childWindow) {                   
                //     setTimeout(function () { childWindow?.close(); }, 3);                                    
                // }
            }
        }        
    }

    clipboardCopy(copyText: string){
        var txtObj = document.createElement('textarea');
        txtObj.value = copyText;
        document.body.appendChild(txtObj);
    
        txtObj.select();
        document.execCommand('copy');
        document.body.removeChild(txtObj);
        splash(this.$t('복사하였습니다').toString(), null);


    }

    async callIPT(contactNumber: string){
        let called = contactNumber.trim().replaceAll('-', '');
        let caller = this.user.officeTel.trim().replaceAll('-','');

        if(!caller){
            (window as any).alertAsync('발신자의 전화번호 정보가 없습니다.');
            return;
        }

        if(!called){
            (window as any).alertAsync('수신 전화번호 정보가 없습니다.');
            return;
        }

        let userid = this.user.personCode;

        let reqparam: orgmap.RequestCallIPT = {
            called: called,
            caller: caller
        }

        if(userid){
            reqparam = {
                ...reqparam,
                userid: userid
            }
        }
        

        if(await (window as any).confirmAsync('caller: ' + caller +'\n' +'called: ' + called+'\n')){
            api.ipt.call(reqparam).then((res:any)=>{
                let msg = res.toString();
                if(msg.indexOf('Error')!=-1){
                    (window as any).alertAsync(msg);
                }
            });
        }
    }
}
